import { maxLength } from "./validators";
import { invalidCharacters } from "utils/common";

const CREATIVE_NAME_PATTERN = /^[ ,a-zA-Z0-9_+/\\\-().:«»~ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ&!@#$%^*=|]+$/;
export const CREATIVE_NAME_MAX_LENGTH = 500;
export const NATIVE_MAX = 500;
const VAST_URL_PATTERN = new RegExp("^https?://\S+\.\S+", "i");
const VAST_URL_MAX_LENGTH = 64000;

export const CREATIVE_FILENAME_MAX_LENGTH = 250;

export function creativeNameAllowedChars(value){
	const invalidCharactersFunc = invalidCharacters(CREATIVE_NAME_PATTERN, value);
	const NAME_ERROR_MESSAGE = `${invalidCharactersFunc.join(" ")} ${invalidCharactersFunc.length > 1 ? 'are' : 'is'} not permitted in creative names`;
	return invalidCharactersFunc.length ? NAME_ERROR_MESSAGE : undefined;
}

export const creativeNameMaxLength = maxLength(CREATIVE_NAME_MAX_LENGTH);
export const creativeFilenameMaxLength = maxLength(CREATIVE_FILENAME_MAX_LENGTH);
export const nativeNameMaxLength = maxLength(NATIVE_MAX);

export function partnerVastURL(value){
	return VAST_URL_PATTERN.test(value);
}

export const partnerVastURLMax = maxLength(VAST_URL_MAX_LENGTH);
